<div class="grid gap-10 mt-8 sm:gap-8">
	<!-- featured courses  -->
	@if (subjectKeywords()?.length) {
		<div class="grid gap-8">
			@for (uni of subjectKeywords(); track uni.university.name) {
				<uc-featured-course
					[uni]="uni"
					[product]="product()"
					class="md:col-span-3"
				/>
			}
		</div>
	}

	<!-- all courses -->
	@for (uni of unis(); track trackUni(uni.id, $index)) {
		@if (uni.type === 'recommended') {
			<uc-featured-course [uni]="$any(uni)" [product]="product()" />
		} @else if (uni.courses && uni.logo && uni.cover_image && uni.paid_features) {
			<uc-university-card
				[uniName]="uni.name"
				[uniSlug]="uni.slug"
				[uniId]="uni.id"
				[uniLogo]="uni.logo"
				[uniCover]="uni.cover_image"
				[externalUrl]="uni.external_url"
				[clientFeatures]="uni.paid_features"
				[saved]="uni.saved"
				[recommended]="uni.recommended_percentage"
				[product]="product()"
				[displaySeeCoursesBtn]="uni.courses_count > 2"
				[searchTerm]="searchTerm()"
				[privacyPolicyUrl]="uni.privacy_policy_url ?? ''"
				[externalUgProspectusUrl]="
					product() === 'undergraduate' ? uni.external_prospectus_url : ''
				"
				[externalPgProspectusUrl]="
					product() === 'postgraduate' ? uni.external_prospectus_url : ''
				"
				[ugSearchOrderPosition]="uni.order"
			>
				<div courses class="pb-4 mt-6 border-t border-b sm:pb-0 sm:border-b-0">
					<uc-course-card-container
						[courses]="uni.courses"
						[clientFeatures]="uni.paid_features"
						[uniSlug]="uni.slug"
						[uniId]="uni.id"
						[product]="product()"
						[externalUrl]="uni.external_url"
						[uniName]="uni.name"
						[ugSearchOrderPosition]="uni.order"
					/>
				</div>
			</uc-university-card>
		}
	}
</div>
